export default __webpack_public_path__ + "static/media/hero-med.1033b50e.svg";